const LOCAL_HOSTNAME = '192.168.233.141'
const LOCAL_API_PORT = 7001
const DEV_LOCAL_HOSTNAME = process.env.REACT_APP_API_URL || 'http://localhost'
// const PROD_API_URL = 'https://smartdepo.uz'
const PROD_API_URL = 'https://saint.uz'

const isDev = process.env.NODE_ENV === 'development'
const isLocal = !isDev && typeof window !== 'undefined' && window.location.hostname === LOCAL_HOSTNAME

const API_BASE_URL = isDev
	? DEV_LOCAL_HOSTNAME
	: isLocal
		? `http://${LOCAL_HOSTNAME}:${LOCAL_API_PORT}`
		: PROD_API_URL

const WS_BASE_URL = isDev
	? DEV_LOCAL_HOSTNAME
	: isLocal
		? `http://${LOCAL_HOSTNAME}:${LOCAL_API_PORT}`
		: PROD_API_URL

export {
	isDev,
	isLocal,
	API_BASE_URL,
	WS_BASE_URL
}
